import type React from "react";
import {memo, useContext, useEffect} from "react";

import {useToastUI} from "../../../components/ui/toast";
import ToastContext from "../../contexts/ToastContext";

const ToastSetter: React.FC = () => {
    const toast = useToastUI();
    const {setToast} = useContext(ToastContext);
    useEffect(() => {
        setToast(toast);
    }, [toast, setToast]);
    return null;
};

export default memo(ToastSetter);
